/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatSourceModel } from './ChatSourceModel';
import {
    ChatSourceModelFromJSON,
    ChatSourceModelFromJSONTyped,
    ChatSourceModelToJSON,
    ChatSourceModelToJSONTyped,
} from './ChatSourceModel';

/**
 * 
 * @export
 * @interface ChatExchangeModel
 */
export interface ChatExchangeModel {
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    prompt: string;
    /**
     * 
     * @type {Date}
     * @memberof ChatExchangeModel
     */
    askedOn: Date;
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    answer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    thoughts?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    error?: string | null;
    /**
     * 
     * @type {Array<ChatSourceModel>}
     * @memberof ChatExchangeModel
     */
    sources?: Array<ChatSourceModel> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatExchangeModel
     */
    threadId: string;
}

/**
 * Check if a given object implements the ChatExchangeModel interface.
 */
export function instanceOfChatExchangeModel(value: object): value is ChatExchangeModel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('askedOn' in value) || value['askedOn'] === undefined) return false;
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    return true;
}

export function ChatExchangeModelFromJSON(json: any): ChatExchangeModel {
    return ChatExchangeModelFromJSONTyped(json, false);
}

export function ChatExchangeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatExchangeModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'prompt': json['prompt'],
        'askedOn': (new Date(json['askedOn'])),
        'answer': json['answer'] == null ? undefined : json['answer'],
        'thoughts': json['thoughts'] == null ? undefined : json['thoughts'],
        'error': json['error'] == null ? undefined : json['error'],
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(ChatSourceModelFromJSON)),
        'threadId': json['threadId'],
    };
}

export function ChatExchangeModelToJSON(json: any): ChatExchangeModel {
    return ChatExchangeModelToJSONTyped(json, false);
}

export function ChatExchangeModelToJSONTyped(value?: ChatExchangeModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'prompt': value['prompt'],
        'askedOn': ((value['askedOn']).toISOString()),
        'answer': value['answer'],
        'thoughts': value['thoughts'],
        'error': value['error'],
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(ChatSourceModelToJSON)),
        'threadId': value['threadId'],
    };
}

